webpackJsonp([155402202473113],{

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/(072)OPA-918-98.4c6b7ce4.jpg";

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 41.4 40.2", height: "6em", width: "6em" }, props),
	    _react2.default.createElement("path", {
	      d: "M31.42 14.55v-1.56c.02-.6-.2-.72-.17-1.06.13-1.48.96-1.58-.44-1.75-1.4-.18-3.51-.44-4.36-.64-1.91-.46-3.81-.98-5.72-1.46-.73-.19-1.53-.21-2.18-.55-.96-.5-1.82-1.18-2.7-1.79a.13.13 0 0 0-.18.04c-.88 1.3-2.36 3.34-2.44 3.65-.13.6-1.4 1.65-1.83 2.14-.74.84-1.5 1.6-1.8 2.8-.03.12-.07.25-.12.37l-.04.1-.11.28-.06.1-.13.27-.06.1-.16.26-.05.08-.19.28-.04.06-.22.3-.02.03c-.16.2-.43.35-.49.6-.05.25.1.7.08.96-.03.26-.18 2.7-.9 3.59a10.48 10.48 0 0 0-2.43 5.43c-.16 1.2-.39 1.4 1.23 1.5.57.03 2.08-.02 2.54.05a321 321 0 0 1 8.79 1.53c.52.1 1.7.9 2.01 1 2.35.28 4.28-.14 6.68.98.64.3 1.1-.1 2.25.57.32.19 2.6 0 3.68 0 1.42.02 2.84.01 4.44 0a.2.2 0 0 0 .19-.24 24.24 24.24 0 0 1-.7-3.43c-.16-2.86-2.1-6.06-3.07-9.24a40.77 40.77 0 0 1-1.28-5.35",
	      fill: "#303030"
	    }),
	    _react2.default.createElement(
	      "g",
	      { fill: "#fff" },
	      _react2.default.createElement("path", { d: "M20.678 16.812a3.37 3.37 0 0 0-1.305.265 3.356 3.356 0 0 0-1.286.96 3.39 3.39 0 0 0-.619 1.137 3.32 3.32 0 0 0-.083 1.671 3.32 3.32 0 0 0 .702 1.459 3.402 3.402 0 0 0 1.594 1.073 3.328 3.328 0 0 0 1.673.083 3.328 3.328 0 0 0 1.46-.7 3.402 3.402 0 0 0 1.075-1.594 3.32 3.32 0 0 0 .083-1.67 3.32 3.32 0 0 0-.702-1.46 3.402 3.402 0 0 0-1.594-1.073 3.328 3.328 0 0 0-.998-.151zm0 1.159a2.265 2.265 0 0 1 .86.172 2.186 2.186 0 0 1 1.342 2.027 2.258 2.258 0 0 1-.172.86 2.182 2.182 0 0 1-1.584 1.295 2.224 2.224 0 0 1-.891 0 2.2 2.2 0 0 1-1.255-.753 2.19 2.19 0 0 1-.49-1.628 2.218 2.218 0 0 1 .363-1.006 2.189 2.189 0 0 1 1.827-.967zm3.498-2.115a.8.806 0 0 0-.08.004.8.806 0 0 0-.079.013.8.806 0 0 0-.077.02.8.806 0 0 0-.075.027.8.806 0 0 0-.072.035.8.806 0 0 0-.069.042.8.806 0 0 0-.063.049.8.806 0 0 0-.059.055.8.806 0 0 0-.053.06.8.806 0 0 0-.046.066.8.806 0 0 0-.04.07.8.806 0 0 0-.033.073.8.806 0 0 0-.025.077.8.806 0 0 0-.017.078.8.806 0 0 0-.01.08.8.806 0 0 0-.002.057.8.806 0 0 0 .004.08.8.806 0 0 0 .012.08.8.806 0 0 0 .02.078.8.806 0 0 0 .027.076.8.806 0 0 0 .035.073.8.806 0 0 0 .042.068.8.806 0 0 0 .048.064.8.806 0 0 0 .055.06.8.806 0 0 0 .06.052.8.806 0 0 0 .065.047.8.806 0 0 0 .07.04.8.806 0 0 0 .072.033.8.806 0 0 0 .076.026.8.806 0 0 0 .078.017.8.806 0 0 0 .08.01.8.806 0 0 0 .056.002.8.806 0 0 0 .08-.004.8.806 0 0 0 .08-.012.8.806 0 0 0 .077-.02.8.806 0 0 0 .075-.028.8.806 0 0 0 .072-.035.8.806 0 0 0 .068-.042.8.806 0 0 0 .064-.048.8.806 0 0 0 .059-.055.8.806 0 0 0 .053-.06.8.806 0 0 0 .046-.066.8.806 0 0 0 .04-.07.8.806 0 0 0 .033-.074.8.806 0 0 0 .025-.076.8.806 0 0 0 .017-.079.8.806 0 0 0 .01-.08.8.806 0 0 0 .002-.057.8.806 0 0 0-.004-.08.8.806 0 0 0-.012-.08.8.806 0 0 0-.02-.078.8.806 0 0 0-.027-.076.8.806 0 0 0-.035-.072.8.806 0 0 0-.042-.069.8.806 0 0 0-.048-.064.8.806 0 0 0-.055-.059.8.806 0 0 0-.06-.053.8.806 0 0 0-.065-.047.8.806 0 0 0-.07-.04.8.806 0 0 0-.072-.033.8.806 0 0 0-.076-.025.8.806 0 0 0-.078-.018.8.806 0 0 0-.08-.01.8.806 0 0 0-.057-.002z" }),
	      _react2.default.createElement("path", { d: "M20.041 13.6c-.366 0-.692.001-.985.005-.293.004-.553.011-.786.021a12.823 12.823 0 0 0-.885.07 5.728 5.728 0 0 0-.447.075 3.762 3.762 0 0 0-.549.166 4.425 4.425 0 0 0-.582.286 2.644 2.644 0 0 0-.432.325 4.472 4.472 0 0 0-.57.632 2.615 2.615 0 0 0-.248.426 4.053 4.053 0 0 0-.298.92c-.02.108-.04.224-.055.353-.017.128-.03.269-.042.425-.012.156-.022.327-.03.519-.008.19-.014.401-.019.635a127.896 127.896 0 0 0-.004 3.073c.006.397.014.739.027 1.031a18.687 18.687 0 0 0 .046.737c.01.1.02.19.031.27a2.9 2.9 0 0 0 .037.209 4.72 4.72 0 0 0 .214.703 3.688 3.688 0 0 0 .313.608 3.229 3.229 0 0 0 .934.94c.087.058.174.112.26.16a3.266 3.266 0 0 0 .849.332c.106.026.218.049.338.069.12.02.247.036.383.05.136.015.281.028.437.038.156.01.323.018.502.024.277.01.696.016 1.179.019a127.609 127.609 0 0 0 3.046-.024c.214-.005.405-.01.563-.016a6.227 6.227 0 0 0 .816-.072 4.668 4.668 0 0 0 .609-.143 4.054 4.054 0 0 0 .573-.228c.097-.047.176-.086.244-.124a1.696 1.696 0 0 0 .372-.274 8.4 8.4 0 0 0 .452-.452 3.02 3.02 0 0 0 .156-.182 1.933 1.933 0 0 0 .22-.35c.05-.098.096-.19.136-.277.04-.089.075-.173.106-.26a2.858 2.858 0 0 0 .144-.56 5.53 5.53 0 0 0 .046-.354c.013-.13.024-.273.034-.434.01-.161.018-.34.025-.541a71.081 71.081 0 0 0 .038-1.422 64.916 64.916 0 0 0-.052-3.605c-.01-.177-.02-.333-.032-.461a3.192 3.192 0 0 0-.146-.741 4.293 4.293 0 0 0-.228-.6 3.54 3.54 0 0 0-.31-.52 3.162 3.162 0 0 0-1.216-1.008 6.027 6.027 0 0 0-.29-.134 3.16 3.16 0 0 0-.586-.182 4.35 4.35 0 0 0-.364-.057 8.47 8.47 0 0 0-.458-.039c-.173-.01-.367-.019-.589-.026-.221-.006-.47-.012-.753-.016a158.192 158.192 0 0 0-2.174-.019zm.634 1.158c.625 0 1.25.003 1.76.01.255.004.482.008.665.013a5.615 5.615 0 0 1 .987.1 3.248 3.248 0 0 1 .485.143 2.306 2.306 0 0 1 .41.213 2.213 2.213 0 0 1 .355.293 2.32 2.32 0 0 1 .303.373 1.952 1.952 0 0 1 .21.447c.028.083.053.172.075.266.022.095.042.195.058.303.017.108.032.223.044.346a9.92 9.92 0 0 1 .048.832 99.323 99.323 0 0 1-.002 4.127 14.698 14.698 0 0 1-.059.957 5.276 5.276 0 0 1-.056.39 2.637 2.637 0 0 1-.435 1.008 1.99 1.99 0 0 1-.653.568 2.42 2.42 0 0 1-.436.192 3.484 3.484 0 0 1-.333.094c-.117.027-.24.05-.369.07a4.015 4.015 0 0 1-.313.019c-.157.006-.361.011-.597.016a147.157 147.157 0 0 1-3.464.025c-.263-.001-.5-.004-.696-.007a12.473 12.473 0 0 1-.785-.038 7.828 7.828 0 0 1-.543-.066 3.39 3.39 0 0 1-.422-.104 2.226 2.226 0 0 1-.526-.253 2.557 2.557 0 0 1-.346-.267 1.956 1.956 0 0 1-.479-.71 3.275 3.275 0 0 1-.146-.471 4.62 4.62 0 0 1-.068-.367 6.793 6.793 0 0 1-.068-.903c-.005-.213-.01-.47-.011-.755a113.66 113.66 0 0 1 .037-3.763c.007-.257.016-.478.025-.648.004-.085.01-.157.014-.214.005-.057.01-.1.016-.125a6.314 6.314 0 0 1 .109-.44 2.592 2.592 0 0 1 .133-.342 1.761 1.761 0 0 1 .18-.289 2.3 2.3 0 0 1 .247-.279c.059-.058.117-.112.175-.162a2.202 2.202 0 0 1 .367-.25 1.991 1.991 0 0 1 .428-.17c.079-.022.162-.042.251-.06a7.27 7.27 0 0 1 .607-.08c.08-.007.218-.013.4-.018.181-.005.406-.01.66-.013.509-.007 1.133-.01 1.758-.01z" })
	    )
	  );
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _boutonInstagram = __webpack_require__(283);
	
	var _boutonInstagram2 = _interopRequireDefault(_boutonInstagram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'a',
	    { href: 'https://www.instagram.com/projet_ludovica/', className: 'etiquette' },
	    _react2.default.createElement(_boutonInstagram2.default, null),
	    _react2.default.createElement(
	      'span',
	      null,
	      'Instagram'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _OPA = __webpack_require__(846);
	
	var _OPA2 = _interopRequireDefault(_OPA);
	
	var _panoramic = __webpack_require__(24);
	
	var _panoramic2 = _interopRequireDefault(_panoramic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _panoramic2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'metadata--wrapper' },
	            _react2.default.createElement('img', { src: _OPA2.default, alt: '' }),
	            _react2.default.createElement(
	                _info2.default,
	                null,
	                'Aux abords du chantier naval du Port de Qu\xE9bec, la cit\xE9 ouvri\xE8re construite pour loger les travailleurs. Photographe inconnu.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _imageFooterFlaneur = __webpack_require__(298);
	
	var _imageFooterFlaneur2 = _interopRequireDefault(_imageFooterFlaneur);
	
	var _btnInstagram = __webpack_require__(295);
	
	var _btnInstagram2 = _interopRequireDefault(_btnInstagram);
	
	var _hamburger = __webpack_require__(62);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeCoinDuFlaneur = function LeCoinDuFlaneur() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'hamburger' } }),
	            _react2.default.createElement(_sidebarLeft2.default, null),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(_hamburger2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Le coin du fl\xE2neur'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Le web, c\'est \xE9norme. Vous vous \xEAtes rendus jusqu\'ici. Laissez une trace et, si le coeur vous en dit, laissez-nous des suggestions de lieux, de personnages et de d\xE9marches. Nous ne sommes pas des bombes r\xE9actives, mais on prend le temps de lire: qui sait ce qui nous arr\xEAtera.'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:ludovicalefilm@gmail.com' },
	                    'ludovicalefilm@gmail.com'
	                )
	            ),
	            _react2.default.createElement(
	                _sidebarRight2.default,
	                null,
	                _react2.default.createElement(_btnInstagram2.default, null)
	            )
	        ),
	        _react2.default.createElement(_imageFooterFlaneur2.default, null)
	    );
	};
	
	exports.default = LeCoinDuFlaneur;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-le-coin-du-flaneur-js-7041ef3822b42e27aa61.js